import httpManager from "@/app/shared/utils/httpManager";
import {
  ReportTypes,
  CustomerSupportReportTypes,
  CustomerSupportReportTypesNames,
} from "@/app/reports/utils/enums";

export async function downloadUserManagementType({ filters } = {}) {
  const [year, month] = filters?.month?.split("-");

  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `year=${year}&`;
  query += `month=${month}`;

  const type = CustomerSupportReportTypesNames[CustomerSupportReportTypes.UsersManagement];

  const url = `/reports/${ReportTypes.CustomerSupport}/download/?type=${type}&${query}`;

  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
